// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getAnalytics } from "firebase/analytics";
import { firebaseApp } from "./firebaseApp";

export const analytics = getAnalytics(firebaseApp);
